module.exports = __webpack_public_path__ + "static/media/legal-bg.225c5036.jpg";